import { APPOINTMENT_AMENDABLE_STATUSES } from 'features/order-tracker/store/sagas/services/helpers/constants';

// eslint-disable-next-line no-unused-vars
import { AppointmentStrategy } from './AppointmentStrategy';

export class DefaultAppointmentStrategy implements AppointmentStrategy {
  getInfoType = (): null => null;

  isReminderAvailable = (appointment: common.EngineerAppointment): boolean =>
    APPOINTMENT_AMENDABLE_STATUSES.includes(appointment.status);

  isSiteContactAvailable = (appointment: common.EngineerAppointment): boolean => !!appointment.siteContact;

  isAmendable = (): boolean => false;

  isApplicable = (): boolean => true;

  isHelpSectionAvailable = (): boolean => false;
}
